import { PropTypes } from "prop-types";

import QoeListComponent from "../../../QoeListComponent";
import { useI18n } from "../../../../i18n/useI18n";
import { COLOR } from "../../../../utils/enums";

const SummaryDetails = ({ summaryData, isQoEMetric }) => {
  const { tCommon } = useI18n('common');
  const availabilityLabels = isQoEMetric ?
    [
      tCommon('appDashboardQOEGoodLabel'),
      tCommon('appDashboardQOEFairLabel'),
      tCommon('appDashboardQOEPoorLabel'),
      tCommon('appDashboardQOEUnknownLabel')
    ] :
    [
      tCommon('sitesHigh'),
      tCommon('sitesFair'),
      tCommon('sitesLow'),
      tCommon('sitesUnknown')
    ]
  const { high, fair, low, gray } = summaryData;
  return (
    <div className="map-summary">
      <div className="map-summary-qoes">
        <QoeListComponent
          iconType={[COLOR.GOOD, COLOR.FAIR, COLOR.POOR, COLOR.GRAY]}
          qoeScore={[high, fair, low, gray]}
          qoeLabels={[...availabilityLabels]}
        />
      </div>
    </div>
  );
};

SummaryDetails.propTypes = {
  summaryData: PropTypes.object.isRequired,
  isQoEMetric: PropTypes.bool
};

export default SummaryDetails;
